import React, { useState } from 'react'
import CallServiceTable from '../../components/Tables/CallServiceTable';
import { Button } from '../../components/Buttons';
import { useDialog } from '../../contexts/DialogContext';
import { DialogConfirmation } from '../../components/Modal';
import { H3 } from '../../components/Text';
import FormDefault from '../../components/Forms/FormDefault';
import * as Yup from "yup";
import { requestAuth } from '../../components/services/RequestService';
import { toast } from 'react-toastify';

const Circular = () => {
  const [reload, setReload] = useState(false);
  const { openDialog, dialogClose } = useDialog();

  async function uploadFile(values) {
    // const { data, onClose, reload, fieldName, procedureId } = props;
    let formData = new FormData();
    formData.append("Name", values.name);
    formData.append("File", values.url);
    formData.append("originalName", values.url.name);
    formData.append("Status", "verified");
    // formData.append("ProcedureId", values.procedureId);
    await requestAuth("post", "/files", formData)
      .then((res) => {
        onSubmit({ ...values, url: res.data.url, name: values.url.name, id: values.id });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function onSubmit(values) {
    console.log(values)
    await requestAuth(
      values.isUpdate ? "put" : "post",
      `/circular`,
      values
    )
      .then(() => {
        setReload(x => !x);
        dialogClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function createData(data, isUpdate = false) {
    openDialog(
      // <DialogConfirmation
      //   children={
      //     <H3>¿Estas seguro que quieres generar el reporte de los tramites?</H3>
      //   }
      //   onClose={dialogClose}
      //   method="put"
      //   url="/files/generalFormat"
      //   texBtn="Generar"
      // // handleSuccess={viewLinkExcel}
      // />
      <div className='mb-5'>
        <FormDefault
          tittle={isUpdate ? "Editar archivo" : "Adicionar archivo"}
          fields={[
            {
              label: "Archivo",
              name: "url",
              type: "file",
              typeInput: "file",
            },
            {
              label: "Tipo de documento",
              name: "type",
              urlApi: "/dropdown/tiposDeDocumentosParaNormativas/options",
              typeInput: "selectGet",
              value: "name",
              labelOption: "name",
            },
            {
              label: "Nro. Circular/Resolución",
              name: "resolution",
              placeholder: "Nro...",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Fecha",
              name: "registerDate",
              placeholder: "Nro...",
              type: "date",
              typeInput: "date",
            },
            {
              label: "Descripción",
              name: "description",
              placeholder: "Descripción del archivo",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Tipo",
              name: "procedureTypeId",
              urlApi: "/procedureType",
              typeInput: "selectGet",
              value: "id",
              labelOption: "name",
            },
          ]}
          initialValues={{
            url: data?.url ?? null,
            procedureTypeId: data?.procedureTypeId ?? null,
            resolution: data?.resolution ?? "",
            registerDate: data?.registerDate?.split("T")[0] ?? "",
            description: data?.description ?? "",
            type: data?.type ?? "",
            name: data?.name ?? "",
            id: data?.id ?? null,
            number: data?.number,
            isUpdate: isUpdate,
          }}
          validationSchema={Yup.object().shape({
            url: Yup.mixed().required("Campo requerido.").nullable(),
          })}
          onSubmit={(values) =>
            typeof values.url === "string"
              ? onSubmit({ ...values, name: data?.name })
              : uploadFile(values)
          }
          buttonName="Registrar"
        />
      </div>
    );
  }

  function updateData(data) {
    createData(data, true)
  }

  function handleDelete(circular) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el tramite?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/circular/${circular.id}`}
        texBtn="Eliminar"
        handleSuccess={() => setReload(x => !x)}
      />
    );
  }

  function handleView(data) {
    if (data.url) {
      window.open(data.url, "_blank", "noopener,noreferrer");
    } else {
      toast.error("El archivo no está disponible.");
    }
  }

  return (
    <>
      <CallServiceTable
        reload={reload}
        component={({ reload }) => {
          return (
            <>
              <Button
                position="left"
                content="Adjuntar circular"
                onClick={() => createData()}
              >
                <i className="far fa-file-pdf"></i>
              </Button>
            </>
          );
        }}
        addFilters={[
          {
            name: "name",
            label: "Nombre",
            filter: true,
          },
          {
            name: "resolution",
            label: "Resolución",
            filter: true,
          }
        ]}
        urlApi="/circular"
        // downloadUrl="/tradecruz/openprocedures"
        // download={true}
        filters={[
          {
            name: "procedureTypeId",
            url: "/procedureType",
            label: "Tipo",
            // defRefValue: 1,
            // defRefLabel: "Importación",
            valueOption: "id",
            labelOption: "name",
          },
          {
            name: "type",
            url: "/dropdown/tiposDeDocumentosParaNormativas/options",
            label: "Tipo de documento",
            // defRefValue: 1,
            // defRefLabel: "Importación",
            valueOption: "name",
            labelOption: "name",
          },
        ]}
        header={[
          { name: "number", label: "Número" },
          { name: "name", label: "Nombre" },
          { name: "type", label: "Tipo de documento", },
          { name: "procedureTypeName", label: "Tipo", },
          { name: "description", label: "Descripción" },
          { name: "resolution", label: "Nro. Circular/Resolución" },
          { name: "registerDate", label: "Fecha", type: 'date', dateFormat: "DD/MM/YYYY" },
          {
            name: "manage",
            type: "action",
            label: "Gestionar",
            sticky: true,
            actions: [
              {
                label: "Editar",
                icon: "fas fa-edit",
                action: updateData,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Eliminar",
                icon: "fas fa-trash",
                action: handleDelete,
                color: "text-[#ff2d55]",
              },
              {
                label: "Ver",
                icon: "far fa-file-pdf",
                action: handleView,
                color: "text-[#1d4ed8]",
              },
            ],
          },
        ]}
        onClick={(a) => console.log(a)}
      />
    </>
  )
}

export default Circular